import { CONFIG_TYPE, GRAPHIC_UPLOADER_GALLERY_MODE } from './types';

/**
 * One attachments behaviour for issues, inspections and inspection templates:
 * add tile + subtle drop zone instead of the legacy "Add files" bar, any file
 * type (issues never restricted it). `addMenuActions` offers "from
 * documentation" only where `WithImportFromDocumentation` is mounted (issues).
 * Spread first, then the place-specific fields (baseUrl, binder, previewOnly).
 */
export const ATTACHMENTS_UPLOADER_PRESET = {
  galleryMode: GRAPHIC_UPLOADER_GALLERY_MODE.ISSUE_ATTACHMENTS,
  showAddTileOnly: true,
  addMenuActions: true,
  file_types: undefined,
} satisfies Partial<CONFIG_TYPE>;

